import FieldString from "../../../generic/string/string"
import FieldConfig from "../../../../fields3/proto/field-config"
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import {FIELD_CONDITIONS_NAME} from "../../../conditions/string"

export default class FieldTaskTitle extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Task Title";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Task title"

        this.variableName       = '{TASK-TITLE}'

        this.conditionTypes     = FIELD_CONDITIONS_NAME
    }

    // sortValue(value:string) { return value}

}